/*
 * @Author: cc
 * @LastEditTime: 2023-12-27 09:05:12
 */

import logo from "@root/img/logo_company.png";
/*
 * @Author: changcheng
 * @LastEditTime: 2023-09-15 09:50:57
 */
import { useEffect, useRef, useState } from "react";
import { UserOutlined, SafetyCertificateOutlined } from "@ant-design/icons";
import { Modal, Button, Form, Input, message } from "antd";
import {
  sndSmsCode,
  validatePhoneNumber,
  checkSmsCode,
  queryRegisterOrNot,
  getUserInfo,
} from "@root/common/service";
import { setRegisterType } from "@root/reducers/register";
import { useDispatch, useSelector } from "react-redux";
import ConfirmUserInfo from "@root/pages/home/confirmUserInfo/index";
import { setUserInfo } from "@root/reducers/user";
import { RootState } from "@root/store";
import "./_index.scss";
import { useNavigate } from "react-router-dom";
import { postLeaveAdvertisementTime } from "@root/common/utils";
const { Search } = Input;
const Register = () => {
  const navigate = useNavigate();
  const { xy_home_login } = useSelector(
    (state: RootState) => state.advertisementData
  );
  const [showRegister, setShowRegister] = useState(false);
  const registerType = useSelector((state: RootState) => state.registerType);
  const dispatch = useDispatch();
  const [liked, setLinked] = useState<boolean>(false);
  const formRef = useRef<any>();
  const [time, setTime] = useState(60);
  const [showConfirmUserInfo, setShowConfirmUserInfo] = useState(false);
  /**
   * 获取短信验证码
   * @returns
   */
  const querySmsCode = async () => {
    if (liked) {
      return;
    }
    const { phonenumber } = formRef.current!.getFieldsValue(true);
    const { data } = await queryRegisterOrNot(phonenumber);
    // 是否已报名
    if (data) {
      message.info("用户已报名");
      return;
    }
    const validatePhoneNumber = await checkUserPhoneNumber();
    // 用户手机存在，并且是注册，直接return
    if (validatePhoneNumber) {
      message.info("用户信息已注册，请直接登录，初始密码为手机号后6位");
      navigate("/login");
      return;
    }
    if (!phonenumber) {
      message.info("请填写手机号");
      return;
    }
    const { code, msg } = await sndSmsCode(phonenumber);
    if (code === 200) {
      countDown();
      message.success(msg);
    }
  };
  //倒计时
  const countDown = () => {
    if (liked) {
      return;
    }
    setLinked(true);
    // 倒计时
    const active = setInterval(() => {
      //获取接口
      setTime((preSecond) => {
        if (preSecond <= 1) {
          setLinked(false);
          clearInterval(active);
          return 60;
        }

        return preSecond - 1;
      });
    }, 1000);
  };
  /**
   * 查看用户手机号是否存在
   */
  const checkUserPhoneNumber = async () => {
    const { phonenumber } = formRef.current!.getFieldsValue(true);
    const { data } = await validatePhoneNumber(phonenumber);
    return data;
  };
  /**
   * 注册
   * @param values
   */
  const onFinish = async (values: any) => {
    const { phonenumber, smsCode } = values;
    const { data } = await checkSmsCode(phonenumber, smsCode);
    if (!data) {
      message.info("验证码错误或已失效,请重新发送");
      return;
    }
    // 需要补充信息
    dispatch(
      setUserInfo({
        userName: phonenumber,
      })
    );
    dispatch(setRegisterType("register"));
    setShowConfirmUserInfo(true);
  };
  useEffect(() => {
    var startTime = new Date().valueOf() / 1000;
    return () => {
      postLeaveAdvertisementTime(xy_home_login, startTime);
    };
  }, []);
  return (
    <div
      className="login_box"
      style={{
        background: `url(${
          xy_home_login.length > 0 ? xy_home_login[0].imageUrl : ""
        })`,
        backgroundSize: "100% 100%",
      }}
    >
      <div className="submit_box">
        <h2>注册</h2>
        <Form
          name="basic"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          autoComplete="off"
          style={{
            width: "360px",
            margin: "0 auto",
          }}
          ref={formRef}
        >
          {/* {registerType === "banner" && (
            <p
              className="viewMeetingDate"
              onClick={() => {
                showMeetingImg();
              }}
            >
              查看会议日程
            </p>
          )} */}
          <Form.Item
            name="phonenumber"
            rules={[{ required: true, message: "请输入11位手机号" }]}
          >
            <Input
              size="large"
              addonBefore={<UserOutlined />}
              placeholder="请输入11位手机号"
            />
          </Form.Item>
          <Form.Item
            name="smsCode"
            rules={[{ required: true, message: "请输入短信验证码" }]}
          >
            <Search
              placeholder="请输入短信验证码"
              allowClear
              style={{
                padding: 0,
              }}
              enterButton={
                <Button type="primary" onClick={querySmsCode}>
                  &emsp;{liked ? `${time}秒后重发` : " 获取验证码"}&emsp;
                </Button>
              }
              size="large"
              addonBefore={<SafetyCertificateOutlined />}
            />
          </Form.Item>
          <Form.Item
            style={{
              textAlign: "center",
            }}
          >
            <Button type="primary" htmlType="submit">
              确定
            </Button>
          </Form.Item>
        </Form>
      </div>
      <ConfirmUserInfo
        setShowConfirmUserInfo={setShowConfirmUserInfo}
        showConfirmUserInfo={showConfirmUserInfo}
      />
    </div>
  );
};
export default Register;
